// EmailJS Configuration
// To get these values:
// 1. Go to https://www.emailjs.com/
// 2. Create a free account
// 3. Add email service (Gmail, Outlook, etc.)
// 4. Create an email template
// 5. Get your Public Key from Account page

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
  TEMPLATE_ID: 'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
  PUBLIC_KEY: 'YOUR_PUBLIC_KEY', // Replace with your EmailJS public key
};

// Template variables that will be sent:
// - from_name: User's name
// - from_email: User's email
// - phone: User's phone (optional)
// - message: User's message
// - to_email: Your email (info@mcabinetdesign.com.au)

